import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/';
import dentalPlugin from './plugin/sueyoshi_plugin';
import './registerServiceWorker';
import VueHead from 'vue-head';


Vue.config.productionTip = false;

Vue.use(dentalPlugin);
Vue.use(VueHead);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
